import Alert from '@mui/material/Alert'
import CheckIcon from '@mui/icons-material/Check'
import { UserActions } from 'Components/SharedComponents/Surveys/UserActions/UserActions'
import {
  Description,
  StepContainer,
  Title,
} from 'Components/SharedComponents/Surveys/Surveys.styled'
import { ActionElementType } from 'Components/SharedComponents/Surveys/constants'
import { NextActions } from 'Components/SharedComponents/Surveys/NextActions/NextActions'
import {
  ButtonAction,
  CustomAction,
} from 'Components/SharedComponents/Surveys/types'
import { HandleActionArgs, PartialUserSurvey } from '../types'
import { CheckInSurveyStepper } from './CheckInSurveyStepper'
import { PriorityReview } from './PriorityReview'

type YourOrgMissionImpactProps = {
  checkInSurveyComments: string
  onAnyAction: ({ nextStep, callback }: HandleActionArgs) => void
  onChangeCheckInSurveyComments: (comments: string) => void
  userSurvey: PartialUserSurvey
}

export const ThankYou = ({
  checkInSurveyComments,
  onAnyAction,
  onChangeCheckInSurveyComments,
  userSurvey,
}: YourOrgMissionImpactProps) => {
  const goToDashboard = () => {
    window.location.href = '/impact/dashboard'
  }

  const userActions: CustomAction[] = [
    {
      callback: (...args: unknown[]) =>
        onChangeCheckInSurveyComments(args[0] as string),
      label: 'Use the space below to add any additional comments (Optional)',
      type: ActionElementType.TEXT_FIELD,
      value: checkInSurveyComments,
    },
  ]

  const nextActions: ButtonAction[] = [
    {
      callback: goToDashboard,
      label: 'Go to Dashboard',
      saveUserState: true,
      type: ActionElementType.BUTTON,
    },
  ]

  return (
    <StepContainer>
      <CheckInSurveyStepper completed step={2} />
      <Title>Thank you!</Title>
      <Alert icon={<CheckIcon fontSize='inherit' />} severity='success'>
        Your answers have been successfully submitted
      </Alert>
      <Description>
        As an organization leader you will be able to see your previous and
        updated responses on the Priorities section of the Dashboard under
        Resilia’s Impact menu.
      </Description>
      <PriorityReview userSurvey={userSurvey} />
      <UserActions onAnyAction={onAnyAction} userActions={userActions} />
      <NextActions nextActions={nextActions} onAnyAction={onAnyAction} />
    </StepContainer>
  )
}
